import AcadlyLogoSquareIcon from '../../../../../icons/AcadlyLogoSquare';
import ReadonlyTitle from './ReadonlyTitle';
import ResetTimerButton from './ResetTimerButton';
import { headerClasses, Root } from './styles';
import Title from './Title';
import useHeader from './vm';

const Header = () => {
  const { isPresenting } = useHeader();

  return (
    <Root>
      <AcadlyLogoSquareIcon size={48} />
      {isPresenting ? (
        <ReadonlyTitle className={headerClasses.title} />
      ) : (
        <Title className={headerClasses.title} />
      )}
      {isPresenting && <ResetTimerButton edge="end" />}
    </Root>
  );
};

export default Header;
